import React from 'react';

import { AdditionalMarkups } from './AdditionalMarkups';
import { InvoiceAddressee } from './InvoiceAddressee';
import { CompanyLogo } from './CompanyLogo';
import { CompanyDocuments } from './CompanyDocuments';
import { HotelList } from './HotelList';
import { CompanyManagers } from './CompanyManagers';
import { CompanyIncentives } from './CompanyIncentives';
import { SimpleTabs } from 'ui/SimpleTabs';
import { Departments } from './Departments';
import { Memberships } from './Memberships';
import { Finances } from './Finances';
import classnames from 'classnames';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';

interface ICompanySettingsTabsProps {
  companyUuid: string;
  isEditMode: boolean;
}

export const CompanySettingsTabs: React.FC<ICompanySettingsTabsProps> = ({ companyUuid, isEditMode }) => {
  const { dynamicParameters } = useDynamicParameters();

  const className = classnames({
    'o:w-[922px] o:pt-0': dynamicParameters.ENABLE_CRM_WORKSPACE_TEMP,
  });
  const tabSelectorClassName = classnames({
    'o:mt-[10px]': dynamicParameters.ENABLE_CRM_WORKSPACE_TEMP,
  });

  const companySettingsTabs = [
    {
      title: 'Mark-Ups',
      name: 'additional-markups',
      styles: '',
      styleObject: { minWidth: '93px' },
      renderContent: () => <AdditionalMarkups isEditMode={isEditMode} />,
    },
    {
      title: 'Hotels',
      name: 'hotel-list',
      styles: '',
      styleObject: { minWidth: '70px' },
      renderContent: () => <HotelList companyUuid={companyUuid} isEditMode={isEditMode} />,
    },
    {
      title: 'Travel Agents',
      name: 'travel-agents',
      styles: '',
      styleObject: { minWidth: '118px' },
      renderContent: () => <CompanyManagers companyUuid={companyUuid} isEditMode={isEditMode} />,
    },
    {
      title: 'Incentives',
      name: 'incentives',
      styles: '',
      styleObject: { minWidth: '93px' },
      renderContent: () => <CompanyIncentives companyUuid={companyUuid} isEditMode={isEditMode} />,
    },
    {
      title: 'Invoices',
      name: 'invoice-addressee',
      styles: '',
      styleObject: { minWidth: '81px' },
      renderContent: () => <InvoiceAddressee companyUuid={companyUuid} isEditMode={isEditMode} />,
    },
    {
      title: 'Departments',
      name: 'departments',
      styles: '',
      styleObject: { minWidth: '112px' },
      renderContent: () => <Departments companyUuid={companyUuid} isEditMode={isEditMode} />,
    },
    {
      title: 'Memberships',
      name: 'memberships',
      styles: '',
      styleObject: { minWidth: '119px' },
      renderContent: () => <Memberships companyUuid={companyUuid} isEditMode={isEditMode} />,
    },
    {
      title: 'Finances',
      name: 'finances',
      styles: '',
      styleObject: { minWidth: '88px' },
      renderContent: () => <Finances companyUuid={companyUuid} isEditMode={isEditMode} />,
    },
    {
      title: 'Logo',
      name: 'company-logo',
      styles: '',
      styleObject: { minWidth: '63px' },
      renderContent: () => <CompanyLogo companyUuid={companyUuid} isEditMode={isEditMode} />,
    },
    {
      title: 'Uploads',
      name: 'uploads',
      styles: '',
      styleObject: { minWidth: '85px' },
      renderContent: () => <CompanyDocuments isEditMode={isEditMode} />,
    },
  ];

  return (
    <SimpleTabs className={className} tabSelectorClassName={tabSelectorClassName} tabConfig={companySettingsTabs} />
  );
};
